import { useMutation } from '@tanstack/react-query';

import { captureException, captureMessage } from '../../logger/Logger';
import { useMastraClient } from '../providers/MastraClient';

export interface ResumeWorkflowRunParams<T extends Record<string, unknown>> {
    workflowId: string;
    runId: string;
    resourceId?: string;
    step: string;
    resumeData: T;
}

export const useResumeWorkflow = <T extends Record<string, unknown>>() => {
    const mastraClient = useMastraClient();

    return useMutation<unknown, Error, ResumeWorkflowRunParams<T>>({
        mutationFn: async ({
            workflowId,
            runId,
            resourceId,
            step,
            resumeData,
        }): Promise<void> => {
            try {
                const workflow = mastraClient.getWorkflow(workflowId);
                const run = await workflow.createRun({ runId, resourceId });

                const result = await run.resumeAsync({
                    step,
                    resumeData,
                });
                captureMessage(
                    `Resuming workflow: { runId: ${runId}, status: ${result.status}}`,
                );
            } catch (e) {
                captureException(e);
                throw e;
            }
        },
    });
};
